import { CircularProgress } from "@mui/material";

export function LoadingDiv({children}){
    return (
        <div style={{display:'flex',alignItems:'center',flexDirection:'column'}}>
            <p>{children||'Carregando..'}</p>
            <CircularProgress/>
        </div>
    )
}